(() => {
  window.fxlCartAdd = formData => new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open('POST', `${window.Shopify?.routes?.root || '/'}cart/add.js`);
    request.setRequestHeader('Accept', 'application/json');
    request.timeout = 20000;
    request.onload = () => {
      let result;
      try { result = JSON.parse(request.responseText); } catch { reject(new Error('Cart response could not be read')); return; }
      if (request.status >= 200 && request.status < 300) resolve(result);
      else reject(new Error(result.description || result.message));
    };
    request.onerror = request.ontimeout = () => reject(new Error('Network error'));
    request.send(formData);
  });
  const root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', event => {
    const stepper = event.target.closest('[data-fxl-quantity-step]');
    if (stepper) {
      const field = stepper.closest('[data-fxl-quantity]')?.querySelector('input[name="quantity"]');
      if (!field) return;
      event.preventDefault();
      const step = Number(field.step) || 1;
      const minimum = Number(field.min) || 1;
      const maximum = field.max ? Number(field.max) : Infinity;
      const current = Number(field.value);
      const position = (Number.isFinite(current) ? current - minimum : 0) / step;
      const next = minimum + (Number(stepper.dataset.fxlQuantityStep) > 0 ? Math.floor(position) + 1 : Math.ceil(position) - 1) * step;
      const validMaximum = Number.isFinite(maximum) ? minimum + Math.floor((maximum - minimum) / step) * step : Infinity;
      if (validMaximum < minimum) return;
      field.value = String(Math.min(validMaximum, Math.max(minimum, next)));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const scroll = event.target.closest('[data-fxl-scroll]');
    if (scroll) {
      const track = document.getElementById(scroll.getAttribute('aria-controls'));
      track?.scrollBy({ left: track.clientWidth * Number(scroll.dataset.fxlScroll), behavior: reduced.matches ? 'instant' : 'smooth' });
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const modal = event.target.closest('[role="dialog"][aria-modal="true"]');
    if (!modal) return;
    const fields = [...modal.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
    if (!fields.length) return;
    if (event.shiftKey && event.target === fields[0]) { event.preventDefault(); fields.at(-1).focus(); }
    else if (!event.shiftKey && event.target === fields.at(-1)) { event.preventDefault(); fields[0].focus(); }
  });
  const enhance = container => {
    container.querySelectorAll('[data-fxl-country]').forEach(country => {
      if (country.dataset.initialized) return;
      country.dataset.initialized = 'true';
      const province = country.closest('form')?.querySelector('[data-fxl-province]');
      const defaultCountry = country.dataset.default;
      if (defaultCountry) {
        const option = [...country.options].find(option => option.value === defaultCountry || option.textContent === defaultCountry);
        if (option) country.value = option.value;
      }
      const update = () => {
        if (!province) return;
        let options = [];
        try { options = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch {}
        province.replaceChildren(...options.map(([value,label]) => new Option(label,value)));
        if (province.dataset.default) province.value = province.dataset.default;
        province.closest('label').hidden = !options.length;
        province.disabled = !options.length;
      };
      country.addEventListener('change', update);
      update();
    });
    container.querySelectorAll('img[data-src]').forEach(img => {
      if (!img.getAttribute('src')) img.src = img.dataset.src;
      if (img.dataset.srcset && !img.srcset) img.srcset = img.dataset.srcset;
      img.loading ||= 'lazy';
    });
    container.querySelectorAll('a[href="#"]').forEach(a => { if (a.classList.contains('fxl-native__collection')) a.removeAttribute('href'); });
  };
  enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
